import clsx from 'clsx';

export interface TabDef {
  key: string;
  label: string;
  /** Row count badge. Omit for tabs without a countable collection. */
  count?: number;
}

interface TabsProps {
  tabs: TabDef[];
  active: string;
  onChange: (key: string) => void;
}

export function Tabs({ tabs, active, onChange }: TabsProps) {
  return (
    <div
      role="tablist"
      className="flex items-end gap-1 overflow-x-auto overflow-y-hidden border-b border-gray-200 dark:border-zinc-700"
    >
      {tabs.map((tab) => {
        const isActive = tab.key === active;
        const isEmpty = tab.count === 0;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.key)}
            className={clsx(
              '-mb-px flex items-center gap-2 whitespace-nowrap rounded-t-md border-b-2 px-3 py-2 text-sm font-medium transition-colors',
              isActive
                ? 'border-blue-500 bg-blue-50 text-gray-900 dark:bg-zinc-700/60 dark:text-zinc-100'
                : clsx(
                    'border-transparent hover:text-gray-900 dark:hover:text-zinc-100',
                    isEmpty
                      ? 'text-gray-400 dark:text-zinc-500'
                      : 'text-gray-500 dark:text-zinc-400',
                  ),
            )}
          >
            {tab.label}
            {tab.count !== undefined && (
              <span
                className={clsx(
                  'rounded-full px-1.5 py-px text-xs font-semibold tabular-nums',
                  isActive
                    ? 'bg-blue-100 text-blue-700 dark:bg-blue-500/20 dark:text-blue-300'
                    : 'bg-gray-100 text-gray-500 dark:bg-zinc-700 dark:text-zinc-400',
                )}
              >
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
